import { render, staticRenderFns } from "./PriorityCart.vue?vue&type=template&id=5ca83cc0&scoped=true&"
import script from "./PriorityCart.vue?vue&type=script&lang=js&"
export * from "./PriorityCart.vue?vue&type=script&lang=js&"
import style0 from "./PriorityCart.vue?vue&type=style&index=0&id=5ca83cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca83cc0",
  null
  
)

export default component.exports